// User-friendly mapping for Firebase Auth error codes (localization key version)
// Use i18n translation keys for toast messages

export const firebaseAuthErrorKeys = {
    "auth/email-already-in-use": "authError.emailInUse",
    "auth/invalid-email": "authError.invalidEmail",
    "auth/operation-not-allowed": "authError.operationNotAllowed",
    "auth/weak-password": "authError.weakPassword",
    "auth/missing-password": "authError.missingPassword",
    "auth/user-disabled": "authError.userDisabled",
    "auth/user-not-found": "authError.userNotFound",
    "auth/wrong-password": "authError.wrongPassword",
    "auth/invalid-verification-code": "authError.invalidVerificationCode",
    "auth/invalid-verification-id": "authError.invalidVerificationId",
    "auth/too-many-requests": "authError.tooManyRequests",
    "auth/invalid-phone-number": "authError.invalidPhoneNumber",
    "auth/missing-phone-number": "authError.missingPhoneNumber",
    "auth/phone-number-already-exists": "authError.phoneNumberInUse",
    "auth/account-exists-with-different-credential":
        "authError.accountExistsWithDifferentCredential",
    "auth/invalid-credential": "authError.invalidCredential",
    "auth/invalid-recipient-email": "authError.invalidRecipientEmail",
    "auth/invalid-sender": "authError.invalidSender",
    "auth/invalid-message-payload": "authError.invalidMessagePayload",
    "auth/missing-android-pkg-name": "authError.missingAndroidPkgName",
    "auth/missing-continue-uri": "authError.missingContinueUri",
    "auth/missing-ios-bundle-id": "authError.missingIosBundleId",
    "auth/invalid-continue-uri": "authError.invalidContinueUri",
    "auth/unauthorized-continue-uri": "authError.unauthorizedContinueUri",
    "auth/requires-recent-login": "authError.requiresRecentLogin",
    "auth/network-request-failed": "authError.networkRequestFailed",
    default: "authError.default",
};

export function getFirebaseAuthErrorMessage(error, t) {
    if (!error) return t(firebaseAuthErrorKeys["default"]);
    if (typeof error === "string" && firebaseAuthErrorKeys[error]) {
        return t(firebaseAuthErrorKeys[error]);
    }
    if (error.code && firebaseAuthErrorKeys[error.code]) {
        return t(firebaseAuthErrorKeys[error.code]);
    }
    return error.message || t(firebaseAuthErrorKeys["default"]);
}
